import React from 'react'

import { Button, ButtonProps } from 'primitives/button'

import { useCallAction } from '../../../calls/use_call_action'

export type CallButtonProps = {
  topicId: number
  showLabel?: boolean
  callType?: 'audio' | 'video'
} & ButtonProps

export const CallButton = React.forwardRef<HTMLButtonElement, CallButtonProps>(
  ({ children, className, topicId, showLabel = true, callType,  ...props }, ref) => {
    const { icon, label, disabled, ...buttonProps } = useCallAction(topicId, callType || 'audio')

    return (
      <Button
        id="call-btn"
        {...props}
        className={className}
        saturated={true}
        ref={ref}
        title={label}
        disabled={disabled}
        {...buttonProps}
      >
        {icon}
        {showLabel && <span>{label}</span>}
      </Button>
    )
  },
)

CallButton.displayName = 'CallButton'
